export const stringToLink = (heading: string) =>
    heading
        .toLowerCase()
        .trim()
        .replace(/[\W_^-]+/g, '-');
